import React, { useState } from 'react';
import FirstTimeModal from './firstTimeModal';
import { resetAllFirstTimeStates, resetFirstTimeState } from '../../utils/firstTimeModalUtils';

const TestModal = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRoute, setSelectedRoute] = useState('invoice_create');

  const routeOptions = [
    { value: 'invoice_create', label: 'Invoice Create', titleKey: 'creating_invoice' },
    { value: 'invoice_calculate', label: 'Invoice Calculate', titleKey: 'calculating_cost' },
    { value: 'template_create', label: 'Template Create', titleKey: 'creating_template' },
    { value: 'template_edit', label: 'Template Edit', titleKey: 'editing_template' },
    { value: 'claim_create', label: 'Claim Create', titleKey: 'creating_claim' },
    { value: 'tracking', label: 'Tracking', titleKey: 'tracking_cargo' },
  ];

  const handleShowModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleResetAll = () => {
    resetAllFirstTimeStates();
    alert('All first-time modal states have been reset!');
  };

  const handleResetSpecific = () => {
    resetFirstTimeState(selectedRoute);
    alert(`First-time modal state for ${selectedRoute} has been reset!`);
  };

  return (
    <div style={{ padding: '2rem', maxWidth: '600px', margin: '0 auto' }}>
      <h1>First-Time Modal Test</h1>
      
      <div style={{ marginBottom: '2rem' }}>
        <h3>Test Controls</h3>
        
        <div style={{ marginBottom: '1rem' }}>
          <label>
            Select Route Type:
            <select 
              value={selectedRoute} 
              onChange={(e) => setSelectedRoute(e.target.value)}
              style={{ marginLeft: '1rem', padding: '0.5rem' }}
            >
              {routeOptions.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </label>
        </div>

        <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
          <button 
            onClick={handleShowModal}
            style={{
              padding: '0.75rem 1.5rem',
              backgroundColor: '#17C653',
              color: 'white',
              border: 'none',
              borderRadius: '0.5rem',
              cursor: 'pointer'
            }}
          >
            Show Modal
          </button>
          
          <button 
            onClick={handleResetSpecific}
            style={{
              padding: '0.75rem 1.5rem',
              backgroundColor: '#FFA500',
              color: 'white',
              border: 'none',
              borderRadius: '0.5rem',
              cursor: 'pointer'
            }}
          >
            Reset Selected Route
          </button>
          
          <button 
            onClick={handleResetAll}
            style={{
              padding: '0.75rem 1.5rem',
              backgroundColor: '#F8285A',
              color: 'white',
              border: 'none',
              borderRadius: '0.5rem',
              cursor: 'pointer'
            }}
          >
            Reset All Routes
          </button>
        </div>
      </div>

      <div style={{ marginBottom: '2rem' }}>
        <h3>Instructions</h3>
        <ul>
          <li>Select a route type from the dropdown</li>
          <li>Click "Show Modal" to display the first-time modal</li>
          <li>Use "Reset Selected Route" to reset localStorage for that route</li>
          <li>Use "Reset All Routes" to reset all first-time modal states</li>
          <li>Navigate to actual routes to see the modal in action</li>
        </ul>
      </div>

      <div style={{ marginBottom: '2rem' }}>
        <h3>Console Commands</h3>
        <p>You can also use these commands in the browser console:</p>
        <ul>
          <li><code>window.firstTimeModalUtils.resetAllFirstTimeStates()</code></li>
          <li><code>window.firstTimeModalUtils.resetFirstTimeState('invoice_create')</code></li>
          <li><code>window.firstTimeModalUtils.getAllFirstTimeStates()</code></li>
        </ul>
      </div>

      {/* First Time Modal */}
      <FirstTimeModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        routeType={selectedRoute}
        videoUrl="https://videocdn.cdnpk.net/videos/6985997f-67dd-4ec1-b166-24d918240c1b/horizontal/previews/watermarked/large.mp4"
        titleKey={routeOptions.find(opt => opt.value === selectedRoute)?.titleKey || 'instruction'}
        descriptionKey="watch_short_instruction"
      />
    </div>
  );
};

export default TestModal; 